import { useAppDispatch } from '../store'
import {
  asyncLogin,
  LoginFormValues,
  resetApiResult,
  UserState,
} from '../store/userSlice'
import { useLocation, useNavigate } from 'react-router'
import LoginForm from './Popup/LoginForm'
import { UserRole } from '../models/User'
import styled from 'styled-components'
import { asyncGetJobCategories } from '../store/mainSlice'

const Login = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const onLogin = async (values: LoginFormValues) => {
    dispatch(resetApiResult())
    const us = await dispatch(asyncLogin(values))

    const uss: UserState = us.payload as UserState
    const redirectUri =
      location.state?.from ||
      (uss.me.userRole == UserRole.MENTEE
        ? '/mentee'
        : uss.me.userRole == UserRole.MENTOR
        ? '/mentor'
        : '/admin/jobclass')
    navigate(redirectUri)

    // 로그인시 JobCategories를 가져온다
    await dispatch(asyncGetJobCategories())
  }

  return (
    <Container>
      <LoginForm onLogin={onLogin} />
    </Container>
  )
}

const Container = styled.div`
  margin: 20px auto;
`

export default Login
